import React from 'react';
import { AlertTriangle, Shield, CheckCircle2, Building2 } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';

export default function RegulatoryDisclaimer() {
  return (
    <div className="bg-[#070E1B] text-white min-h-screen font-opensans flex flex-col justify-between">
      <SEOHead 
        title="Regulatory Disclaimers & Consumer Disclosures | Grow & Stay Rich"
        description="Comprehensive FINRA/NAIC regulatory notices, IRC Sec. 7702 MEC tax rules, zero market downside carrier guarantees, and Living Benefits disclosures."
        path="/disclaimer"
      />

      <div>
        <Navigation />

        <div className="relative pt-24 pb-16 border-b border-[#C9A84C]/25 overflow-hidden">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#162236] border border-[#C9A84C]/30 text-xs font-semibold text-[#E8D4A0] tracking-wider uppercase">
              <AlertTriangle className="w-4 h-4 text-[#C9A84C]" />
              FINRA / NAIC Regulatory Disclosures
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold font-playfair text-white">Regulatory Disclaimer</h1>
            <p className="text-sm text-slate-300">Consumer Financial & Insurance Regulatory Notices</p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-8 text-sm text-slate-300 leading-relaxed font-opensans">
          
          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0] flex items-center gap-2">
              <Shield className="w-5 h-5 text-[#C9A84C]" />
              1. Non-Investment & Insurance Product Notice
            </h2>
            <p>
              Grow & Stay Rich operates as an independent financial education and life insurance advisory network (NPN: 21450620). Contracting and licensing portals facilitated through SureLC. Member agency affiliated with Hegemon Group International (HGI) / Integrity Marketing Group. Life insurance products (such as Index Universal Life) and Fixed Index Annuities (FIA) are <strong>insurance products</strong> issued by state-regulated life insurance companies. They do not represent direct investments in stock market equities, mutual funds, or securities portfolios.
            </p>
          </section>

          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0] flex items-center gap-2">
              <Building2 className="w-5 h-5 text-[#C9A84C]" />
              2. Contractual Guarantees & Claims-Paying Ability
            </h2>
            <p>
              Contractual guarantees, including 0% market downside floors, cap rates, participation rates, and guaranteed lifetime income options, are backed solely by the financial strength and claims-paying ability of the issuing insurance carriers (such as Allianz, Corebridge Financial, Nationwide, Athene, F&G Life, Lincoln Financial, Mutual of Omaha, Americo, North American, etc.). Guarantees are subject to policy terms, fee structures, and carrier underwriting approval.
            </p>
          </section>

          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0] flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-[#C9A84C]" />
              3. Tax Disclosures & IRC Sec. 7702 Regulations
            </h2>
            <p>
              References to "tax-free" growth, loans, or distributions refer to federal tax treatment of life insurance policy values under Internal Revenue Code Section 7702, assuming the contract remains in force and does not trigger Modified Endowment Contract (MEC) status under IRC Sec. 7702A. Grow & Stay Rich does not provide personalized tax or legal advice. Clients should consult their CPA, tax attorney, or independent tax advisor regarding their individual tax situations.
            </p>
          </section>

          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0]">4. Living Benefits Acceleration Notice</h2>
            <p>
              Living Benefits riders allow policyholders to accelerate death benefits in the event of qualifying critical, chronic, or terminal health conditions. Acceleration payout amounts vary based on carrier underwriting evaluation, policy face value, and severe illness qualification at the time of claim. Riders may involve administrative fees or reduce policy cash surrender values and death benefits.
            </p>
          </section>

          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0]">5. Regulatory Address & Compliance Line</h2>
            <div className="font-mono text-xs bg-[#162236] p-4 rounded-xl border border-[#C9A84C]/20 text-slate-300">
              Grow & Stay Rich Compliance Department<br />
              NPN: 21450620 • Primary Domicile State: Texas (TX)<br />
              HQ Regulatory Address: 2019 Holy Unity Ln, St Paul, TX-75098<br />
              Official Advisory Line: (903) 231-3051 • Email: info@growandstayrich.com
            </div>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
}
